import React from 'react';

const LCVDevStrip = ({phase, activeTermIndex, terms}) => {
  return (
    <div className="lcv-dev-strip">
      <span className="lcv-dev-label">DEV</span>
      <span className="lcv-dev-sep" />
      <span className="lcv-dev-label">Phase:</span>
      <span className="lcv-dev-value">{phase}</span>
      <span className="lcv-dev-sep" />
      <span className="lcv-dev-label">Term:</span>
      <span className="lcv-dev-value">{activeTermIndex + 1}/{terms.length} ({terms[activeTermIndex]?.term || '—'})</span>
    </div>
  );
};

export default LCVDevStrip;
